export const SidebarData1 = {
  assetmgt: [
    {
      label: "Main Menu",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main Menu",
      submenuItems: [
        {
          label: "AHU List",
          link: "/assetmgt/hostasset",
          icon: "wind",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Filter List",
          link: "/assetmgt/assetitems",
          icon: "filter",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Blocks",
          link: "/assetmgt/blocks",
          icon: "map-pins",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Schedule",
          link: "/assetmgt/schedule",
          icon: "calendar-time",
          showSubRoute: false,
          submenu: false,
        },

        {
          label: "Notifications",
          link: "/assetmgt/notifications",
          icon: "bell",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Deviations Alarms",
          link: "/assetmgt/alarms-deviations",
          icon: "clock",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "My Task",
          link: "/assetmgt/tasks",
          icon: "list-check",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Replacement List",
          link: "/assetmgt/replacementlist",
          icon: "replace",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Retirement List",
          link: "/assetmgt/retirementlist",
          icon: "archive",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "My Profile",
          link: "/assetmgt/user-profile",
          icon: "user",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Audit Trail",
          link: "/assetmgt/assetactivitylog",
          icon: "history",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Reports",
          icon: "history",
          showSubRoute: false,
          submenu: true,
          submenuItems: [
            // { label: "Barcode Printing", link: "/assetmgt/reports" },
            // { label: "Alarms", link: "/assetmgt/reports" },
            // { label: "Filter History", link: "/assetmgt/filter-history" },
            { label: "Filter Drying", link: "/assetmgt/dry-report" },
            { label: "Filter Cleaning", link: "/assetmgt/wash-report" },
            // { label: "Audit Trail", link: "/assetmgt/reports" },
          ],
        },
      ],
    },
    {
      label: "Users",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Users",
      submenuItems: [
        {
          label: "Users",
          link: "assetmgt/users",
          icon: "users",
          showSubRoute: false,
          submenu: false,
        },

        {
          label: "Role Permissions",
          link: "/assetmgt/permissions",
          icon: "shield-lock",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Password Policies",
          link: "/assetmgt/password-policies",
          icon: "lock-cog",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Backup Management",
          link: "/assetmgt/backuprestore",
          icon: "lock-cog",
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    {
      label: "Masters",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Masters",
      submenuItems: [
        {
          label: "Filter Types",
          link: "assetmgt/filter-types",
          icon: "filter",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Filter Audit Types",
          link: "/assetmgt/masters/filter-activities",
          icon: "file-search",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "User Audit Types",
          link: "/assetmgt/masters/audit-activities",
          icon: "user-search",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Maintenance Stages",
          link: "assetmgt/maintenance-stages",
          icon: "settings",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Functional Locations",
          link: "/assetmgt/functional-locations",
          icon: "map-pin",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Wash-In reasons",
          link: "/assetmgt/washin-reasons",
          icon: "circle-check",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Wash Equipments",
          link: "/assetmgt/wash-equip",
          icon: "wash-machine",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Dryer Equipments",
          link: "/assetmgt/dryerequip",
          icon: "windmill",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Dryer Temperature Range",
          link: "/assetmgt/temperature-range",

          icon: "windmill",
          showSubRoute: false,
          submenu: false,
        },

        {
          label: "Air Pressure",
          link: "/assetmgt/air-pressure",
          icon: "gauge",
          showSubRoute: false,
          submenu: false,
        },

        {
          label: "RO water Pressure",
          link: "/assetmgt/water-pressure",
          icon: "droplet-half-2",
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
  ],
};
